import { Card } from "@general-backoffice/core";
import type { User } from "@investhinks/api-client";
import React from "react";
import { Badge, Card as RTCard, CardBody as RTCardBody } from "reactstrap";

import List from "../shared/List";

interface UserCardProps {
  user?: Partial<Pick<User, "name" | "email" | "isVIP" | "referrerType">>;
  title?: string;
  onClick?: () => void;
}

const UserCard = ({ user = {}, title, onClick }: UserCardProps) => {
  const { name, email, isVIP, referrerType } = user || {};
  return (
    <RTCard
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
      className="position-relative overflow-auto"
    >
      {!!title && <Card.Header title={title} />}
      <RTCardBody>
        <div className="position-relative w-100">
          <div className="position-absolute d-flex top-0 right-0" style={{ transform: "translateY(-50%)" }}>
            {referrerType && ["AMBASSADOR", "INFLUENCER"].includes(referrerType) && (
              <Badge color="default" children={referrerType} />
            )}
            {isVIP && <Badge color="warning" children={"VIP"} />}
          </div>
        </div>
        <List
          items={[
            {
              title: "Name",
              text: name || "---------",
            },
            {
              title: "Email",
              text: email || "---------@-----.---",
            },
          ]}
        />
      </RTCardBody>
    </RTCard>
  );
};

export default UserCard;
